import React, { useCallback, useEffect } from 'react'
import { isNil } from 'ramda'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

import { useHealthCheck } from 'commons/useHealthCheck'

import MessagespringLoading from 'app/componentV4/Loader/MessagespringLoading'

import { step } from './constants'
import useLogin from './useLogin'
import NewPassword from './NewPassword'
import SuspendedAccount from './SuspendedAccount'
import CreateNewAccount from './CreateNewAccount'
import PermissionRequired from './PermissionRequired'
import VerificationWithOTP from './VerificationWithOTP'
import VerificationApproach from './VerificationApproach'
import VerificationWithPassword from './VerificationWithPassword'
import VerificationEmailOrSocial from './VerificationEmailOrSocial'
import { useDispatch, useSelector } from 'react-redux'
import MessageAlert from 'app/components/MessageAlert'
import { useIntl } from 'react-intl'
import { clearLoginError } from 'app/auth/store/actions'

const LoginV4 = () => {
  const health = useHealthCheck()
  const dispatch = useDispatch()
  const { formatMessage } = useIntl()
  const isShowErrorPlanEnd = useSelector(
    ({ auth }) => auth.login.isShowErrorPlanEnd,
  )

  const {
    state: {
      ref,
      code,
      email,
      page,
      reason,
      isErrorOtp,
      action,
      prevPage,
      newPassword,
      isLoaderPage,
    },
    fetchOTP,
    verifyOTP,
    handlePage,
    handleLogin,
    verifyPassword,
    handleProvider,
    createNewAccount,
    handleNewPassword,
    handleVerifyApproach,
    handleLoaderPage,
    handleFacebook,
  } = useLogin()

  const handleAhealtCheck = useCallback(async () => {
    await health.healtCheck.mutate()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    handleLoaderPage(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page])

  useEffect(() => {
    handleAhealtCheck()
  }, [handleAhealtCheck])

  useEffect(() => {
    const url = new URL(window.location.href)
    const code = url.searchParams.get('code')
    if (!code) return

    const verifier = sessionStorage.getItem('fb_pkce_verifier')
    if (!verifier) return

    handleFacebook(code, verifier)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (isShowErrorPlanEnd) {
      dispatch(
        MessageAlert.showError({
          message: formatMessage({ id: 'permission.restricted.alert.text' }),
        }),
      )
    }
    return () => {
      dispatch(clearLoginError())
    }
  }, [isShowErrorPlanEnd])

  return (
    <>
      {page === step.isLogin && (
        <GoogleReCaptchaProvider
          reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
        >
          <VerificationEmailOrSocial
            onSubmit={(value) => {
              handleLogin.mutate(value)
            }}
            onProvider={(value) => handleProvider(value)}
            isLoading={handleLogin.isPending}
          />
        </GoogleReCaptchaProvider>
      )}
      {page === step.isVerifyApproach && (
        <VerificationApproach email={email} onSubmit={handleVerifyApproach} />
      )}
      {page === step.isPassword && (
        <VerificationWithPassword
          email={email}
          onSubmit={(value) => {
            verifyPassword.mutate(value)
          }}
          isLoading={verifyPassword.isPending}
          onBack={() => handlePage(prevPage)}
        />
      )}
      {page === step.isOTP && (
        <VerificationWithOTP
          email={email}
          reference={ref}
          onSubmit={(value) => {
            !verifyOTP.isPending && verifyOTP.mutate(value)
          }}
          onBack={() => handlePage(prevPage)}
          isError={isErrorOtp}
          reFreshOtp={() => fetchOTP.mutate(action)}
        />
      )}
      {page === step.isNewAccount && (
        <CreateNewAccount
          email={email}
          code={code}
          onSubmit={(value) => createNewAccount.mutate(value)}
          isLoading={createNewAccount.isPending}
          goTo={() => handlePage(step.isSetNewPassword)}
          isPassword={!isNil(newPassword)}
        />
      )}
      {page === step.isSetNewPassword && (
        <NewPassword
          onBack={() => handlePage(prevPage)}
          onSubmit={handleNewPassword}
        />
      )}
      {page === step.isSuspendedAccount && <SuspendedAccount reason={reason} />}
      {page === step.isPermissionRequired && (
        <PermissionRequired onBack={() => handlePage(prevPage)} />
      )}
      {isLoaderPage && (
        <div className="absolute h-full w-full bg-white">
          <div className="flex h-screen">
            <div className="flex justify-center m-auto">
              <MessagespringLoading />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default LoginV4
